// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1DeeH","right":"Footer_right__26NVJ","buttons":"Footer_buttons__35n-1"};